import { UntypedFormGroup, UntypedFormControl, AbstractControl, ValidatorFn } from '@angular/forms';

export function emailValidator(control: UntypedFormControl): { [key: string]: any } {
  var emailRegexp = /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$/;
  if (control.value && !emailRegexp.test(control.value)) {
    return { invalidEmail: true };
  }
}

export function matchingPasswords(passwordKey: string, passwordConfirmationKey: string) {

  return (group: UntypedFormGroup) => {
    let password = group.controls[passwordKey];
    let passwordConfirmation = group.controls[passwordConfirmationKey];
    if (password.value !== passwordConfirmation.value) {
      return passwordConfirmation.setErrors({ mismatchedPasswords: true })
    }
  }
}

export function noWhitespaceValidator(control: UntypedFormControl) {
  const isWhitespace = (control.value || '').trim().length === 0;
  const isValid = !isWhitespace;
  return isValid ? null : { 'required': true };
}
export function dateComparision(fromDate: any, toDate: any) {
  return (group: UntypedFormGroup) => {
    let startDate = group.controls[fromDate];
    let endDate = group.controls[toDate];
    if (endDate.value < startDate.value) {
      return endDate.setErrors({ mismatchedDate: true })
    }
  }


}
export function validateAllFormFields(formGroup: UntypedFormGroup) {
  Object.keys(formGroup.controls).forEach(field => {
    const control = formGroup.get(field);
    control.markAsTouched({ onlySelf: true });
  });
}

export function conditionalValidator(condition: (() => boolean), validator: ValidatorFn): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } => {
    if (!condition()) {
      return null;
    }
    return validator(control);
  }
}

export function constructRule(inputJson: any) {
  inputJson = inputJson.statement;
  inputJson = inputJson.groups[0];
  return constructRuleStmt(inputJson, '', false, '');
}

export function constructRuleStmt(inputJson: any, ruleStmt: string, isGroupNestedGroup: boolean, conjunctor: string) {
  if (conjunctor === 'AND') {
    conjunctor = '&&';
  }
  if (conjunctor === 'OR') {
    conjunctor = '||';
  }
  if (isGroupNestedGroup) {
    ruleStmt = ruleStmt + ' ' + conjunctor + ' ';
    ruleStmt = ruleStmt + ' ( ';
  }

  if (inputJson.hasOwnProperty('conditions')) {
    const jsonArray = (inputJson.conditions as Array<any>);
    for (let i = 0; i < jsonArray.length; i++) {
      const jsonObject = jsonArray[i] as object;
      // @ts-ignore
      ruleStmt = ruleStmt + '$.' + jsonObject.filedName + ' ' + jsonObject.operators + ' "' + jsonObject.fieldValue + '"';
      if (i !== jsonArray.length - 1) {
        let conjunctorTemp = inputJson.conjunctor;
        if (conjunctorTemp === 'AND') {
          conjunctorTemp = '&&';
        }
        if (conjunctorTemp === 'OR') {
          conjunctorTemp = '||';
        }
        ruleStmt = ruleStmt + ' ' + conjunctorTemp + ' ';
      }
    }
  }
  if (inputJson.hasOwnProperty('groups')) {
    const jsonArray = (inputJson.groups as Array<any>);
    for (let i = 0; i < jsonArray.length; i++) {
      const jsonObject = jsonArray[i] as object;
      if (jsonObject['conditions'].length > 0 && jsonObject['groups'].length > 0) {

        ruleStmt = constructRuleStmt(jsonObject, ruleStmt, true, inputJson.conjunctor);
        ruleStmt = ruleStmt + ' ) ';
      }

    }
  }
  return ruleStmt;
}

export const trimValidator: ValidatorFn = (control: UntypedFormControl) => {
  if (control.value.startsWith(' ')) {
    return {
      'trimError': { value: 'control has leading whitespace' }
    };
  }
  if (control.value.endsWith(' ')) {
    return {
      'trimError': { value: 'control has trailing whitespace' }
    };
  }
  return null;
};

export function download(data: any, customFilename?: string) {
  var filename = customFilename;
  if (!filename && data?.headers && data.headers.get('filename') != null) {
    filename = data.headers.get('filename');
  } else if (!filename) {
    filename = 'local_.xls';
  }
  if (filename) {
    filename = filename.replace(/audjustment/gi, (match: string) => {
      return match[0] === 'A' ? 'Adjustment' : 'adjustment';
    });
  }
  var contentType = data?.headers?.get('content-type') || 'application/octet-stream';
  var linkElement = document.createElement('a');
  try {
    var blob = new Blob([data.body], { type: contentType });
    var url = window.URL.createObjectURL(blob);

    linkElement.setAttribute('href', url);
    linkElement.setAttribute("download", filename);

    var clickEvent = new MouseEvent("click", {
      "view": window,
      "bubbles": true,
      "cancelable": false
    });
    linkElement.dispatchEvent(clickEvent);
  } catch (ex) {
  }
}

export function downloadImage(data: any, fileName) {


  //var filename=headers['filename'];

  var filename = fileName;
  var contentType = data.headers.get('content-type');
  var linkElement = document.createElement('a');
  try {
    var blob = new Blob([data.body], { type: contentType });
    var url = window.URL.createObjectURL(blob);

    linkElement.setAttribute('href', url);
    linkElement.setAttribute("download", filename);

    var clickEvent = new MouseEvent("click", {
      "view": window,
      "bubbles": true,
      "cancelable": false
    });
    linkElement.dispatchEvent(clickEvent);
  } catch (ex) {
  }
}



export function downloads(data: any) {
  var filename = 'downloaded.pdf';
  if (data.headers.get('filename')) {
    filename = data.headers.get('filename');
  } else if (data.headers.get('content-disposition')) {
    const contentDisposition = data.headers.get('content-disposition');
    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
    const matches = filenameRegex.exec(contentDisposition);
    if (matches != null && matches[1]) {
      filename = matches[1].replace(/['"]/g, '');
    }
  }

  var contentType = data.headers.get('content-type');
  var linkElement = document.createElement('a');
  try {
    var blob = new Blob([data.body], { type: contentType });
    var url = window.URL.createObjectURL(blob);

    linkElement.setAttribute('href', url);
    linkElement.setAttribute("download", filename);

    var clickEvent = new MouseEvent("click", {
      "view": window,
      "bubbles": true,
      "cancelable": false
    });
    linkElement.dispatchEvent(clickEvent);
  }
  catch (ex) {
  }
}

export function downloadsNew(data: any, fileName) {
  var filename = fileName;
  var contentType = data.headers.get('content-type');
  var linkElement = document.createElement('a');
  try {
    var blob = new Blob([data.body], { type: contentType });
    var url = window.URL.createObjectURL(blob);

    linkElement.setAttribute('href', url);
    linkElement.setAttribute("download", filename);

    var clickEvent = new MouseEvent("click", {
      "view": window,
      "bubbles": true,
      "cancelable": false
    });
    linkElement.dispatchEvent(clickEvent);
  }
  catch (ex) {
  }
}

export function getPageSize(size) {
  if (size >= 10) {
    if (size > 10) {
      return [5, 10, 15];
    }
    else if (size <= 10 && size > 5) {
      return [5, 10];
    }
  }
  else if (size <= 10 && size > 5) {
    return [5, 10];
  }
  return [5, 10];
}


export function LeadgetPageSize(size) {
  if (size >= 10) {
    if (size > 10) {
      return [5, 10, 15, 50, 100, 200];
    } else {
      return [5, 10, 15];
    }
  } else if (size > 5) {
    return [5, 10];
  } else {
    return null;
  }
}


export function resource(size) {



  // let object = {
  //   read: privilegeMapping[0].hasReadPermission,
  //   write:
  // }



}


export class ResourceAccess {
  static paymentSubscription(paymentSubscription: any) {
    throw new Error('Method not implemented.');
  }
  static MigrateDatamappingService(MigrateDatamappingService: any) {
    throw new Error('Method not implemented.');
  }
  public static CREDIT_MEMO = 'creditMemo';
  public static ORDER = 'order';
  public static PURCHASE_REQUEST = 'purchaseRequest';
  public static PURCHASE_APPROVAL = 'purchaseApproval';
  public static PURCHASE_REQUEST_AUTOMATION = 'purchaseRequestAutomation';
  public static INVOICE = 'invoice';
  public static SHIPMENT = 'shipment';
  public static TAX = 'tax';
  public static PROFILE = 'profile';
  public static ADMIN_CUSTOMER = 'adminCustomer';
  public static PRODUCT = 'product';
  public static CATEGORY = 'category';
  public static ATTRIBUTE = 'attribute';
  public static ATTRIBUTE_SET = 'attributeSet';
  public static REVIEW = 'adminReview';
  public static CATALOG_SEARCH_QUERY = 'catalogSearchQuery';
  public static CUSTOMER = 'adminCustomer';
  public static ACCESS = 'userRole';
  public static USERSALESTARGET = 'userSalesTarget';
  public static ACCESS_SET = 'accessSet';
  public static CATALOG_RULE = 'catalogRule';
  public static NEWS_LETTER_SUBSCRIBER = 'adminNewsletterSubscriber';
  public static CMS = 'cmsPage';
  public static ABANDONED_CART = 'abandonedCart';
  public static CART_PRODUCT = 'cartProduct';
  public static CURRENCY = 'adminCurrency';
  public static INDEX = 'Index';
  public static SHIPPING_TABLE_RATE = 'adminShippingTablerate';
  public static ORDER_STATUS = 'orderStatus';
  public static CONFIG = 'adminConfig';
  public static DELIVERY_COUNTRY = 'deliveryCountry';
  public static PRODUCT_CONFIG = 'productCustomization';
  public static COUPON = 'adminCoupon';
  public static PRODUCT_DISCOUNT = 'productDiscount';
  public static PINCODE = 'pincode';
  public static BANNER = 'coreConfigSlider';
  public static TRANSLATE = 'coreTranslate';
  public static CONSULTATION = 'consultation';
  public static LAYOUT = 'layout';
  public static BANNER_ADVANCED = 'coreConfigSliderAdvanced';
  public static UNITS = 'units';
  public static LANGUAGE = 'language';
  public static WAREHOUSETYPE = 'warehouseType';
  public static KITCHENMOSTER = 'kitchenmoster';
  public static PAYMENT_MODE = 'paymentMode';
  public static VENDOR = 'vendor';
  public static WAREHOUSE = 'warehouse';
  public static WEEKENDCONFIG = 'weekendConfig';
  public static CONTACT = 'contact';
  public static FOOTERICON = 'footerIcon';
  public static MEDICAL_DELIVERY_OPTION = 'medicalDelivery';
  public static PURCHASE = 'purchase';
  public static PRODUCT_QTY_REPORT = 'productQtyReport';
  public static COLLEGEREPORT = 'collegeReport';
  public static MEDICAL_DATA_MAPPING = 'medicalDataMapping';
  public static SHOPDATA = 'shopdata';
  public static SUPPLIER_DISCOUNT = 'supplierDiscount';
  public static VENDORDISCOUNT = 'vendorDiscount';
  public static SUPPLIER_COMMISSION = 'supplierCommission';
  public static SALESORDERSTATUS = 'salesOrderStatus';
  public static REFERRAL = 'referral';
  public static REFERRALPRODUCT = 'referralProduct';
  public static REFERALPRODUCTITEM = 'referalProductItem';
  public static REFERALORDERITEMS = 'referalOrderItems';
  public static REFERALPRODUCTORDERITEMBYUSER = 'referalProductOrderItemByUser';
  public static REFERALCUSTOMER = 'referalCustomer';
  public static DYNAMICFORMLABEL = 'dynamicFormLabel';
  public static DYNAMICFORMGROUP = 'dynamicFormGroup';
  public static FORMSUBMISSION = 'formSubmission';
  public static VENDORREGISTRATION = 'vendorRegistration';
  public static SIZECHART = 'sizeChart';
  public static LEAD = 'lead';
  public static COMPANIES = 'companies';
  public static USERGROUP = 'userGroup';
  public static GOOGLECALENDAR = 'GoogleCalendar';
  public static INDIAMARTLEADDATA = 'IndiamartLeadData';
  public static FORECASTEDREVENUEBYDEALSTAGE = 'forecastedRevenueByDealStage';
  public static CRMAUTOMATIONS = 'crmAutomation';
  public static ACCOUNTMANAGER = 'accountManager';
  public static HRMLOCATION = 'hrmLocation';
  public static GEOTRACKING = 'geoTrackingRules';

  public static PROPERTY = 'property';
  public static PROPERTYATTRIBUTE = 'propertyAttributes'
  public static PROPERTYATTRIBUTESET = 'propertyAttributeSet'


  public static LEADFORMIDREPORT = 'leadFormIdReport';

  public static LEADUSERFORMIDREPORT = 'leadUserFormIdReport';


  public static MANAGELEADATTRIBUTESET = 'leadAttributeSet';
  public static MANAGELEADATTRIBUTE = 'leadAttributes';
  public static LEADSOURCE = 'leadSource';
  public static CRMSETTING = 'CrmSetting';
  public static DUPLICATELEAD = 'duplicateLead';
  public static TODAYLEADSCORINGREPORT = 'todayLeadScoringReport';
  public static APICALL_LOG_REPORT = 'apiCallLogReport';
  public static LEADIDBYLEADSCOREREPORT = 'leadIdByLeadScoreReport';
  public static LEADSCORINGREPORT = 'leadScoringReport';
  public static LEADSOURCEINTEGRATION = 'leadSourceIntegration';
  public static VENDORSETTING = 'vendorSetting';
  public static WHATSAPPTEMPLATE = 'whatsAppTemplate';
  public static LEADLOGSREPORT = 'LeadLogsReport';
  public static LEADDYNAMICFORMGROUP = 'leadDynamicFormGroup';
  public static LEADDYNAMICFORMLABEL = 'leadDynamicFormLabel';
  public static COMMISSION = 'Commission';
  public static LEADSTATUS = 'LeadStatus';
  public static CALLOUTCOME = 'callOutcome';
  public static SEQUENCESTAGS = 'sequencesTags';
  public static DEALCLOSINGREASON = 'dealClosingReason';
  public static DEALSTATUS = 'dealStatus';
  public static DEALSSTAGES = 'dealsStages';
  public static AFTERSALESSUBSTATUS = 'afterSalesSubStatus';


  public static PROJECTSTAGES = 'projectStages';
  public static TAGS = 'tags';
  public static INDUSTRYTYPE = 'industryType';
  public static BUSINESSTYPE = 'businessType';
  public static TASKSTATUS = 'taskStatus';
  public static LEADMEETINGSUMMARYREPORT = 'leadMeetingSummaryReport';
  public static LEADTASKREPORT = 'leadTaskReport';
  public static USERDEVICEACTIVITYREPORT = 'userDeviceActivityReport';
  public static USERWEBACTIVITYTRACKINGREPORT = 'userWebActivityTrackingReport';
  public static CONTRACTTYPE = 'contractType';








  public static COMMONSETTINGS = 'commonSettings';
  public static LEADACTIVITYLIST = 'leadActivityList';
  public static USERREPORT = 'userReport';
  public static HRMDAILYUSERTIMESUMMARYREPORT = 'hrmDailyUserTimeSummaryReport';
  public static HRMPROJECTSTATUSREPORT = 'hrmProjectStatusReport';
  public static PIPELINE = 'pipeLine';
  public static DEALSPIPELINE = 'dealsPipeLine';




  public static PENDING = 'pending';
  public static PACKING = 'packing';
  public static READYTOSHIP = 'readyToShip';
  public static INTRANSIT = 'inTransit';
  public static DELIVERED = 'delivered';
  public static CANCEL = 'cancel';






  public static GRID = 'grid';
  public static DEALSGRID = 'dealsGrid';
  public static STAFFREPORT = 'staffReport';
  public static GOOGLECALENDER = 'googleCalender';
  public static SUPPORTTICKETAUTOMATION = 'supportTicketAutomation';
  public static PUSHNOTIFICATIONS = 'pushNotifications';
  public static EMAILSEND = 'emailSend';
  public static INVOICEGENERATOR = 'invoiceGenerator';
  public static WHATSAPPCONTACTGROUP = 'whatsAppContactGroupNew';
  public static CREATECAMPAIGNTEMPLATE = 'createCampaignTemplate';
  public static WHATSAPPCONTACT = 'whatsAppContact';
  public static WHATSAPPMESSAGELOGSREPORT = 'whatsappMessageLogsReport';




  public static CREATETEMPLATE = 'createTemplate';
  public static TEMPLATESCREEN = 'templateScreen';
  public static EMAILSENDEDITOR = 'emailSendEditor';
  public static MAILBOX = 'mailBox';
  public static CONVERSATIONMAIL = 'conversationmail';
  public static SALESREPORT = 'salesReport';
  public static PLANS = 'plans';
  public static PHONENUMBERS = 'phoneNumbers';

  public static ECOMMERCETEMPLATE = 'ecommerceTemplate';




























  public static SUPPORTTICKETMANAGEMENT = 'supportTicketManagement';

  public static GOOGLECALENDARREPORT = 'googleCalendarReport';

  public static INTEGRATIONLIST = 'integrationList';








  public static PRIORITY = 'priority';
  public static TRACKER = 'tracker';
  public static STATUS = 'status';


  public static DASHBAORDTAB = 'dashboardTab';

  public static TECHNICIAN = 'technician';
  public static TECHNICIANRULE = 'technicianRule';
  public static TRANSACTIONHISTORY = 'transactionHistory';
  public static LEADSTATUSREPORT = 'leadStatusReport';
  public static LEADSOURCEREPORT = 'leadSourceReport';
  public static LEADUSERREPORT = 'leadUserReport';
  public static USERCALLREPORT = 'userCallreport';
  public static FOLLOWACTIVITYREPORT = 'followActivityReport';
  public static LEADCUSTOMERREPORT = 'leadCustomerReport';
  public static USERWISESTATUSREPORT = 'userWiseStatusReport';
  public static USERWISESOURCEREPORT = 'userWiseSourceReport';
  public static SOURCESTATUSREPORT = 'sourceStatusReport';


  public static LEADCALLWITHOUTGROUPBYREPORT = 'leadCallRecordReport';
  public static LEADCALLREPORT = 'leadCallReport';
  public static LEADCITYWISE = 'LeadCityWise';
  public static LEADSTATEWISE = 'LeadStateWise';
  public static LEADTYPEWISE = 'LeadTypeWise';
  public static USERCITYWISE = 'userCityWise';
  public static USERSTATEWISE = 'userStateWise';
  public static USERTYPEWISE = 'userTypeWise';
  public static REFERRALLOGINCUSTOMER = 'ReferralCustomers';
  public static IMPORTOR = 'importor'
  public static SMARTVIEWS = 'smartViews';
  public static LEADSCORING = 'leadScoring';

  public static COURSEHISTORYREPORT = 'coursehistoryreport';

  public static LEADCALENDER = 'leadCalender';

  public static ACTIVITYDUE = 'ActivityDue';
  public static ACTIVITYUPCOMING = 'ActivityUpcoming';
  public static WHATSAPPTEMPLATEMESSAGE = 'whatsappTemplateMessage';

  public static OUTOFSTOCKNOTIFICATION = 'outOfStockNotification';

  public static BLOGSECTION = 'blogSection';

  public static ORDERSLAB = 'orderSlab';

  public static SMARTVIEWSLIST = 'SmartViewsList';

  public static PARTNER = 'partner';

  public static PARTNERSTOREDETAILS = 'partnerStoreDetails';

  public static PARTNERAPPROVAL = 'PartnerApproval';

  public static PARTNERDATA = 'PartnerData';

  public static CUSTOMPRODUCTSCOPE = 'customProductScope';

  public static PRODUCTLISTING = 'Productlisting';

  public static BUILDER = 'builder';

  public static LEADACTIVITY = 'leadActivity'

  public static HOUSINGLOCATION = 'housingLocation';

  public static HOUSINGBUILDER = 'housingbuilder';

  public static DOCUMENTS = 'documents'

  public static DOCUMENT = 'document'

  public static DEALS = 'deals';

  public static SPECIFICATION = 'Specification';

  public static MYAPPOINTMENTS = 'myAppointments';

  public static LEAD_PRODUCT_REPORT = 'leadProductReport';

  public static LEAD_OWNER_REPORT = 'leadOwnerReport';

  public static CALLSTAGEREPORT = 'callStageReport';

  public static DEALSUSERREPORT = 'dealsUserReport';



  public static DEALS_GROUP_WISE_REPORT = 'dealsGroupWiseReport';

  public static GOLDGROUP = 'goldGroup';

  public static INTERESTTYPE = 'interestType';

  public static LOANTYPE = 'loanType';

  public static CALCULATEDBY = 'calculatedby';

  public static GOLDLIVERATE = 'goldLiveRate';

  public static GOLDLOANCUSTOMER = 'goldLoanCustomer';

  public static GOLDLOANCHECKER = 'goldLoanChecker';

  public static CUSTOMERLOAN = 'customerLoan';

  public static GOLDLOANRECEIPT = 'goldLoanReceipt';

  public static GOLDITEM = 'goldItem';

  public static DELIVERYSLOTS = 'deliverySlots';

  public static CUSTOMFORMSUBMISSION = 'customformsubmission'

  public static DOCTOR = 'doctor'

  public static PRESCRIPTION = 'prescription'

  public static LIVECONSULTATIONS = 'liveConsultations'

  public static BILLING = 'billing'

  public static LECTURER = 'Lecturer'

  public static PATIENTSENTITY = 'patient'

  public static PATIENTSATTRIBUTES = 'patientsAttribute'

  public static PATIENTSATTRIBUTESET = 'patientsAttributeSet'



  public static CONTACTS = 'contacts'

  public static CONTACTATTRIBUTES = 'contactAttribute'

  public static CONTACTATTRIBUTESET = 'contactAttributeSet'

  public static DEALSATTRIBUTES = 'dealsAttribute'

  public static DEALSATTRIBUTESET = 'dealsAttributeSet'

  public static GOLDLOANCOMPLETEDLISTREPORT = 'goldLoanCompletedListReport';

  public static GOLDLOANPENDINGLISTREPORT = 'goldLoanPendingListReport';

  public static GOLDLONEDUE = 'goldLoanDue';

  public static GOLDLONEUPCOMING = 'goldLoneUpcoming';

  public static SHOWLOCATION = 'showLocation';

  public static SUBSCRIPTION = 'subscription';

  public static POLICY = 'policy';

  public static NOTES = 'notes';

  public static DOCTORSPECIALIST = 'doctorSpecialist';

  public static DOCTORQUALIFICATIONS = 'doctorQualifications';

  public static MLMUSERREPORT = 'mlmUserreport';

  public static MLMORDERREPORT = 'mlmOrderreport';

  public static MLMDASHBOARD = 'mlmDashboard';

  public static LOANNOWISEREPORT = 'loanNoWiseReport';

  public static SUBSCRIPTIONFORM = 'subscription-form';

  public static DASHBOARD = 'dashboard';

  public static REGISTRATION = 'registration';

  public static SALESPERSONTRACKING = 'salesPersonTracking';






  // hr

  public static COMPLAINS = 'complains';

  public static HOLIDAYS = 'holidays';

  public static EXPENSE = 'expense';

  public static NOTICE = 'notice';

  public static USERATTENDENCEREPORT = 'userAttendenceReport';
  public static GEOTRACKINGRULES = 'geoTrackingRules';
  public static ATTENDANCEDASHBOARD = 'attendanceDashboard';
  public static ATTENDANCESETTINGS = 'attendanceSettings';

  public static HRMSETTING = 'hrSetting';

  public static APPRAISAL = 'appraisal';

  public static SECONDARYPRODUCT = 'secondaryProduct';

  public static EMPLOYEELIST = 'employees';

  public static LEAVEREQUEST = 'leaverequest';

  public static DESIGNATION = 'designation';

  public static DEPARTMENT = 'department';

  public static STEPGUIDE = 'stepGuide';

  public static PRICINGTAB = 'pricingTab';

  public static PLANFEATURES = 'planFeatures';

  public static PRODUCTMASTER = 'productMaster';

  public static CLIENTSLISTS = 'clientsLists';

  public static PROJECTS = 'projects';

  public static MEETING = 'meeting';

  public static APPOINTMENTS = 'hrmAppointment';

  public static SUPPORTTICKETS = 'supporttickets';

  public static LEAVEAPPROVAL = 'leaveApproval';

  public static DISCUSSIONS = 'discussions';

  public static USERCALLOVERVIEWREPORT = 'userCallOverviewReport';

  public static TASK = 'task'

  public static TASKATTRIBUTES = 'taskAttribute'

  public static COMPANYATTRIBUTE = 'companyAttribute'

  public static COMPANYATTRIBUTESET = 'companyAttributeSet'


  public static TASKATTRIBUTESET = 'taskAttributeSet'

  public static ROLES = 'roles'

  public static EMPLOYEES = 'employees'

  public static LEAVEAUTOMATIONS = 'leaveAutomations'

  public static MANUALSUBSCRIPTIONREQUEST = 'manualSubscriptionRequest'

  public static MANUALSUBSCRIPTIONAPPROVAL = 'manualSubscriptionApproval'

  public static MANUALSUBSCRIPTIONAUTOMATIONS = 'manualSubscriptionAutomations'

  public static TRAVELPLAN = 'travelplan'

  public static ACCOUNTS = 'accounts'

  public static FACEBOOKPAGE = 'facebookPage'

  public static VENDORSUBSCRIPTION = 'vendorSubscription'

  public static EXPENSECATEGORIES = 'expenseCategories'

  public static WHATSAPPSETTING = 'whatsAppSetting'





  //pos
  public static VARIANTS = 'variants';
  public static CUTTERMASTER = 'cutterMaster';
  public static SUSPENSCATEGORIES = 'suspensCategories';
  public static PRICEGROUP = 'priceGroup';
  public static POSUNITS = 'units';
  public static EXPENSECATEGORY = 'posExpenseCategory';
  public static SYSTEMSETTINGS = 'systemSettings';
  public static POSSETTING = 'posSetting';
  public static CATEGORIES = 'posCategories';
  public static PRINTER = 'printer';
  public static POSWAREHOUSE = 'posWarehouse';
  public static BANK = 'bank';
  public static BRAND = 'brand';
  public static DRUGMANUFACTURERS = 'drugManufacturers';
  public static DRUGDIVISIONS = 'drugDivisions';
  public static METALRATES = 'metalRates';


  public static PROMOS = 'promos';
  public static SUSPENSMASTER = 'suspensMaster';
  public static INVOICELAYOUT = 'invoiceLayout';
  public static POSCURRIENCES = 'posCurriences';
  public static STOCKCOUNT = 'stockCount';
  public static TAXRATE = 'posTaxRate';
  public static POSSUPPLIER = 'posSupplier';
  public static EXPENSES = 'expenses';
  public static GIFTCARDS = 'giftCards';
  public static QUANTITYADJUSTMENTS = 'quantityAdjustments';
  public static POSPRODUCT = 'posProduct';
  public static POSSALES = 'posSales';
  public static TRANSFERS = 'transfers';
  public static RETURN = 'Return';
  public static POSPURCHASE = 'posPurchase';
  public static PURCHASERETURN = 'purchaseReturn';
  public static QUOTATIONS = 'quotations';
  public static PRODUCTION = 'production';
  public static DININGTABLES = 'diningtables';
  public static PRINTBARCODE = 'printBarcode';
  public static POSPAYMENTMODE = 'posPaymentMode';
  public static SUPPLIERREPORT = 'supplierreport';
  public static SUPPLIERPRODUCTSREPORT = 'supplierProductsReport';
  public static DELETEDENTRIESREPORTS = 'deletedEntriesReports';
  public static REGISTERREPORT = 'registerReport';
  public static PRODUCTSREPORT = 'productsReport';
  public static ADJUSTMENTSREPORT = 'adjustmentsReport';
  public static CUSTOMERORDERREPORT = 'customerOrderReport';

  public static CATEGORIESREPORT = 'categoriesReport';
  public static BRANDSREPORT = 'brandsReport';
  public static BANKTRANSACTIONREPORT = 'bankTransactionReport';
  public static PAYMENTSREPORT = 'paymentsReport';
  public static TAXRATEREPORT = 'taxRateReport';
  public static EXPENSEREPORT = 'expenseReport';
  public static PURCHASESREPORT = 'purchasesReport';
  public static PROFITBYPRODUCTREPORT = 'profitByProductReport';
  public static WAREHOUSETRANSACTIONSREPORT = 'warehouseTransactionsReport';
  public static PRODUCTQUANTITYALERTS = 'productQuantityAlerts';
  public static PAYMENT_TYPE = 'paymentType';
  public static PURCHASEORDER = 'purchaseOrder';
  public static SALESORDER = 'salesOrder';
  public static GOODSRECEIVED = 'goodsReceived';
  public static DAYBOOKREPORT = 'daybookreport';
  public static APPROVETRANSACTIONS = 'approvetransactions';
  public static POSUSER = 'posUser';
  public static WHATSAPPCHAT = 'whatsAppChat';
  public static SUPPORTTICKETSETTINGS = 'supportTicketSettings';
  public static SUPPORTTICKETSTATUS = 'supportTicketStatus';
  public static VIDEOLINKS = 'videoLinks';
  public static DEALSSTATUSREPORT = 'dealsStatusReport';
  public static DEALSUSERWISEREPORT = 'dealsUserWiseReport';
  public static DEALSPROBABILITYREPORT = 'dealsProbabilityReport';
  public static DEALSSOURCEREPORT = 'dealsSourceReport';
  public static EMAILTEMPLATE = 'emailTemplate';
  public static WHATSAPPMESSAGELOGS = 'whatsappMessageLogs';
  public static NOTIFICATION = 'adminNotification';
  public static USERMAILCONFIG = 'userMailConfig';
  public static MAILCONFIG = 'mailConfig';
  public static LEADCALLOVERVIEWREPORT = 'leadCallOverViewReport';
  public static LEADSTATUSOVERALLREPORT = 'leadStatusOverAllReport';
  public static CLOSEDREPORTBYLEADSOURCE = 'closedReportByLeadSource';
  public static CALLCONNECTIONSUMMARY = 'callConnectionSummary';
  public static SALESTARGETREPORT = 'salesTargetReport';
  public static SALESCALLHISTORYSUMMARYREPORT = 'salesCallHistorySummaryReport';
  public static WAREHOUSEDAYBOOK = 'warehouseDaybook';
  public static AIAGENTS = 'Aiagents';
  public static NEVERATTENDED = 'neverAttended';
  public static NOTPICKUPBYCLIENT = 'notPickupByClient';
  public static UPCOMINGACCOUNTRENEWAL = 'upcomingAccountRenewal';
  public static OVERDUEACCOUNTRENEWALS = 'overdueAccountRenewals';
  public static CALLHISTORY = 'callHistory';
  public static MANAGEREPORT = 'manageReport';
  public static WORKSESSIONREPORT = 'workSessionReport';

  public static FACEBOOKLEADREPORT = 'faceBookLeadReport';





  public static CLIENTUSERACTIVITYREPORT = 'clientUserActivityReport';
  public static USERWEBACTIVITYREPORT = 'userWebActivityReport';
  public static USERACCOUNTACTIVITYREPORT = 'userAccountActivityReport';















  public static AICHATBOT = 'aiChatBot';
  public static POSCUSTOMERSREPORT = 'posCustomersReport';
  public static PRODUCTEXPIRYALERTS = 'productExpiryAlerts';
  public static DISTRIBUTOR = 'distributor';
  public static ADDONS = 'addOns';
  public static PARTNERECOSYSTEM = 'partnerEcosystem';

  public static BOTREPLIESLIST = 'botRepliesList';
  public static WHATSAPPBOTFLOWS = 'whatsAppBotFlows';
  public static WHATSAPPPRIMARYBOTFLOW = 'whatsAppPrimaryBotFlow';
  public static TEMPLATES = 'templates';
  public static SEQUENCES = 'sequences';
  public static SEQUENCESTASKS = 'sequencesTasks';




  public static WHATSAPPCAMPAIGN = 'whatsappCampaign';
  public static CATALOGPRODUCTPINCODEPRICINGGROUP = 'catalogProductPincodePricingGroup';
  public static QRCODE = 'qrCode';


  public static CHATCAMPAIGN = 'chatCampaign';
  public static CHATTEMPLATESCREEN = 'chatTemplateScreen';
  public static INTERNALCHATBOT = 'internalChatBot';
  public static SUPPORTCHATS = 'supportChats';
  public static CHATCONTACTS = 'chatContacts';
  public static CHATCONTACTGROUP = 'chatContactGroup';
  public static CHATBOTFLOWS = 'chatBotFlows';
  public static CHATBOTREPLY = 'chatBotReply';







































  public static SEO = 'seo';


}


export class Audit {
  public static AUDIT_PRODUCT = "com.calsoft.ecom.model.productindex.ProductIDX2";
  public static AUDIT_USER = "com.calsoft.ecom.model.customerindex.CustomerIDX";
  public static AUDIT_CATEGORY = "com.calsoft.ecom.model.categoryindex.CategoryIDX";
}




export class comparisonValidator {
  /**
* Must match validator
*
* @param controlPath A dot-delimited string values that define the path to the control.
* @param matchingControlPath A dot-delimited string values that define the path to the matching control.
*/
  static mustMatch(controlPath: string, matchingControlPath: string): ValidatorFn {
    return (formGroup: UntypedFormGroup): null => {

      // Get the control and matching control
      const control = formGroup.get(controlPath);
      const matchingControl = formGroup.get(matchingControlPath);

      // Return if control or matching control doesn't exist
      if (!control || !matchingControl) {
        return;
      }

      // Delete the mustMatch error to reset the error on the matching control
      if (matchingControl.hasError('mustMatch')) {
        delete matchingControl.errors.mustMatch;
        matchingControl.updateValueAndValidity();
      }

      // Don't validate empty values on the matching control
      // Don't validate if values are matching
      if (this.isEmptyInputValue(matchingControl.value) || control.value === matchingControl.value) {
        return;
      }

      // Set the validation error on the matching control
      matchingControl.setErrors({ mustMatch: true });
    };
  }

  /**
* Check for empty (optional fields) values
*
* @param value
*/
  static isEmptyInputValue(value: any): boolean {
    return value == null || value.length === 0;
  }

}


export class nullCheckValidator {
  /**
* Must match validator
*
* @param controlPath A dot-delimited string values that define the path to the control.
* @param matchingControlPath A dot-delimited string values that define the path to the matching control.
*/
  static mustMatch(controlPath: string, matchingControlPath: string): ValidatorFn {
    return (formGroup: UntypedFormGroup): null => {

      // Get the control and matching control
      const control = formGroup.get(controlPath);
      const matchingControl = formGroup.get(matchingControlPath);

      // Return if control or matching control doesn't exist
      if (!control || !matchingControl) {
        return;
      }

      // Delete the mustMatch error to reset the error on the matching control
      if (matchingControl.hasError('empty')) {
        delete matchingControl.errors.mustMatch;
        matchingControl.updateValueAndValidity();
      }

      // Don't validate empty values on the matching control
      // Don't validate if values are matching
      if (this.isEmptyInputValue(matchingControl.value)) {
        matchingControl.setErrors({ empty: true });
      }

      if (this.isEmptyInputValue(control.value)) {
        control.setErrors({ empty: true });
      }

      // Set the validation error on the matching control
      matchingControl.setErrors({ empty: true });
    };
  }

  /**
* Check for empty (optional fields) values
*
* @param value
*/
  static isEmptyInputValue(value: any): boolean {
    return value == null || value.length === 0;
  }

}

export function isNumeric(number: any) {

  const numericValue = parseFloat(number);

  if (typeof numericValue === 'number' && !isNaN(number)) {
    return true;
  } else {
    return false;
  }


}


export class lessThanValidator {
  /**
* Must match validator
*
* @param controlPath A dot-delimited string values that define the path to the control.
* @param matchingControlPath A dot-delimited string values that define the path to the matching control.
*/
  static mustMatchDate(controlPath: string, matchingControlPath: string): ValidatorFn {
    return (formGroup: UntypedFormGroup): null => {

      // Get the control and matching control
      const control = formGroup.get(controlPath);
      const matchingControl = formGroup.get(matchingControlPath);

      // Return if control or matching control doesn't exist
      if (!control || !matchingControl) {
        return;
      }

      // Delete the mustMatch error to reset the error on the matching control
      if (matchingControl.hasError('mismatchedDate')) {
        delete matchingControl.errors.mismatchedDate;
        matchingControl.updateValueAndValidity();
      }

      // Don't validate empty values on the matching control
      // Don't validate if values are matching
      if (control.value <= matchingControl.value) {
        return;
      }

      // Set the validation error on the matching control
      matchingControl.setErrors({ mismatchedDate: true });
    };
  }

  /**
* Check for empty (optional fields) values
*
* @param value
*/
  static isEmptyInputValue(value: any): boolean {
    return value == null || value.length === 0;
  }





}


export function numberToWordsNew(value: number): string {
  if (value === 0) return 'zero rupees only';
  if (value < 0) return 'minus ' + numberToWords(-value);

  let words = '';
  let numString = value.toString();
  let numLength = numString.length;
  let crore, lakh, thousand, remainder;

  // Crores
  if (numLength > 7) {
    crore = parseInt(numString.substring(0, numLength - 7), 10);
    numString = numString.substring(numLength - 7);
    numLength = numString.length;
    words += convertChunk(crore) + ' crore ';
  }

  // Lakhs
  if (numLength > 5) {
    lakh = parseInt(numString.substring(0, numLength - 5), 10);
    numString = numString.substring(numLength - 5);
    numLength = numString.length;
    words += convertChunk(lakh) + ' lakh ';
  }

  // Thousands
  if (numLength > 3) {
    thousand = parseInt(numString.substring(0, numLength - 3), 10);
    numString = numString.substring(numLength - 3);
    numLength = numString.length;
    words += convertChunk(thousand) + ' thousand ';
  }

  // Hundreds and below
  remainder = parseInt(numString, 10);
  words += convertChunk(remainder);

  return words.trim() + ' rupees only';
}

const units: string[] = ['', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine'];
const teens: string[] = ['ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'];
const tens: string[] = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];
const thousands: string[] = ['', 'thousand', 'lakh', 'crore'];
export function convertChunk(value: number): string {
  let words = '';

  if (value >= 100) {
    words += units[Math.floor(value / 100)] + ' hundred ';
    value %= 100;
  }
  if (value >= 20) {
    words += tens[Math.floor(value / 10)] + ' ';
    value %= 10;
  }
  if (value >= 10) {
    words += teens[value - 10] + ' ';
  } else if (value > 0) {
    words += units[value] + ' ';
  }

  return words;
}

export function numberToWords(num: number): string {
  const a = ['', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'];
  const b = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];

  if (num.toString().length > 9) return 'overflow';
  let n = ('000000000' + num).substr(-9).match(/(\d{2})(\d{2})(\d{3})(\d{3})/);
  if (!n) return '';
  let str = '';
  str += (n[1] != '00') ? (a[Number(n[1])] || b[n[1][0]] + ' ' + a[n[1][1]]) + ' crore ' : '';
  str += (n[2] != '00') ? (a[Number(n[2])] || b[n[2][0]] + ' ' + a[n[2][1]]) + ' lakh ' : '';
  str += (n[3] != '000') ? (a[Number(n[3])] || b[n[3][0]] + ' ' + a[n[3][1]]) + ' thousand ' : '';
  str += (n[4] != '000') ? (a[Number(n[4])] || b[n[4][0]] + ' ' + a[n[4][1]]) + ' ' : '';
  return str;
}

export function formatScientificNumber(val: any): any {
  if (val === null || val === undefined || val === '' || val === '--') {
    return val;
  }
  const strVal = String(val).trim();
  if (!/[eE]/.test(strVal)) {
    return val;
  }
  const cleanNumStr = strVal.replace(/[^0-9eE\.\+\-]/g, '');
  const match = cleanNumStr.match(/^([+-]?\d+)(?:\.(\d+))?[eE]([+-]?\d+)$/);
  if (!match) {
    const num = Number(cleanNumStr);
    return isNaN(num) ? val : num.toLocaleString('fullwide', { useGrouping: false });
  }
  const sign = match[1].startsWith('-') ? '-' : '';
  let integerPart = match[1].replace(/^[+-]/, '');
  let fractionPart = match[2] || '';
  let exp = parseInt(match[3], 10);

  if (exp === 0) {
    return sign + integerPart + (fractionPart ? '.' + fractionPart : '');
  } else if (exp > 0) {
    if (exp >= fractionPart.length) {
      const zeros = '0'.repeat(exp - fractionPart.length);
      let res = integerPart + fractionPart + zeros;
      res = res.replace(/^0+/, '') || '0';
      return sign + res;
    } else {
      const intSegment = integerPart + fractionPart.slice(0, exp);
      const fracSegment = fractionPart.slice(exp);
      const cleanInt = intSegment.replace(/^0+/, '') || '0';
      return sign + cleanInt + '.' + fracSegment;
    }
  } else {
    const absExp = Math.abs(exp);
    const combined = integerPart + fractionPart;
    if (absExp >= integerPart.length) {
      const zeros = '0'.repeat(absExp - integerPart.length);
      return sign + '0.' + zeros + combined;
    } else {
      const intSegment = integerPart.slice(0, integerPart.length - absExp);
      const fracSegment = integerPart.slice(integerPart.length - absExp) + fractionPart;
      return sign + (intSegment || '0') + '.' + fracSegment;
    }
  }
}

export function formatSecondsToTime(secondsInput: any): string {
  if (secondsInput === null || secondsInput === undefined || secondsInput === '' || secondsInput === '--') {
    return '00:00:00';
  }
  if (typeof secondsInput === 'string' && secondsInput.includes(':')) {
    const parts = secondsInput.split(':');
    const hh = Math.floor(parseFloat(parts[0]) || 0).toString().padStart(2, '0');
    const mm = Math.floor(parseFloat(parts[1]) || 0).toString().padStart(2, '0');
    const ss = Math.floor(parseFloat(parts[2]) || 0).toString().padStart(2, '0');
    return `${hh}:${mm}:${ss}`;
  }
  const val = parseFloat(secondsInput);
  if (isNaN(val) || val < 0) {
    return '00:00:00';
  }
  const totalSeconds = Math.floor(val);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = Math.floor(totalSeconds % 60);
  return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
}


